import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  anyQuest: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
    alignSelf: 'center',
    marginTop: 50,
  },
  contact: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 20,
    color: Colors.GrayPallete.lightgrayThree,
    textAlign: 'center',
    maxWidth: 280,
    alignSelf: 'center',
    marginTop: 10,
  },
  phone: {
    marginTop: 50,
    alignSelf: 'center',
    fontSize: 22,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 26,
    color: Colors.GrayPallete.lightgrayThree,
  },
  service: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    alignSelf: 'center',
    marginBottom: 100,
    marginTop: 10,
    color: Colors.GrayPallete.lightgrayThree,
  },
  scroll: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 15,
  },
  containerHeader: {
    marginTop: 30,
  },
  containerDrop: {
    marginTop: 40,
    borderTopWidth: 1,
    borderColor: Colors.lightGray,
  },
  content: {
    width: '85%',
    alignSelf: 'center',
    marginTop: 30,
  },
  title: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 19,
    color: 'black',
    marginVertical: 20,
  },
  description: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 20,
    color: Colors.GrayPallete.lightgrayThree,
  },
  containerTitle: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});
